
import 'moment';
import 'moment-timezone';
import {CacheUtils as Cache} from '../../utils/CacheUtils';

/**
 * @class BaseModel
 * @extends Backbone.Model
 *
 * @description Utilize common parse/serialize logic to be used across all the models and other modules
 */
export class BaseModel extends Backbone.Model {

    get idAttribute () {

        return 'uuid';
    }

    set microservice (name) {

        this._microservice = name;
        return this;
    }

    get microservice () {

        return this._microservice;
    }

    set resource (name) {

        this._resource = name;
        return this;
    }

    get resource () {

        return this._resource;
    }

    get url () {

        if(this.isNew()){
            return (API_PREFIX + '/' + this.microservice + '/' + this.resource);
        } else {
            return (API_PREFIX + '/' + this.microservice + '/' + this.resource + '/' + this.attributes.uuid);
        }
    }

    validate (attributes, options) {

        let errors = [];

        if (options.fieldsToValidate && options.fieldsToValidate.length) {

            options.fieldsToValidate.forEach((property, index, arr) => {

                let result = this.validateProperty(property, attributes, options);

                if (result) {
                    errors.push(result);
                }
            }, this);
        }

        if (errors.length) {

            return errors;
        }
    }


    /**
     * Overriding native to allow 'silent' option
     * http://backbonejs.org/docs/backbone.html#section-94
     *
     * @param {object} options
     * @param [{string}] options.fieldsToValidate
     * @param {boolean|undefined} options.silent
     */
    isValid (options = {}) {
        if (!options.silent) {
            return super.isValid(options);
        }

        let error = this.validationError = this.validate(this.attributes, options) || null;

        return !error;
    }

    // @FIXME: Disabled caching until a fix is found
    /**
     * extend backbones fetch with caching
     *
     * if the cache is used the model might change after the initial promise resolution
     * it is required to listen on model change events to assert the right data is displayed
     *
     * @param {*} options
     * @return {JQuery.Deferred}
     */
    /*fetch (options) {

        if (Cache.has(this.url, options) && options && options.useCache === true) {
            const def = $.Deferred();

            super.fetch(options).then((data) => {
                Cache.put(this.url, data, options);
            });

            return def.resolve(Cache.get(this.url, options));
        } else {
            return super.fetch(options).then((data) => {
                Cache.put(this.url, data, options);
            });
        }
    }*/

    validateProperty (property, attributes, options) {}

    /**
     * Stringified dates should be provided in ISO-8601 format
     *
     * @param {object|string} start  - object: specifies start and end points of an interval
     *                                 string: represents start point of an interval
     * @param {string}        [end]  - represents end point of an interval
     *
     * @returns {{start, end}}
     */
    static parsePeriod (start, end) {

        if (!start) {

            return {
                start: BaseModel.parseDate(),
                end: BaseModel.parseDate()
            };
        }

        if (typeof start === 'string') {

            return {
                start: BaseModel.parseDate(start ? start : null),
                end: BaseModel.parseDate(end ? end : null)
            };
        }
        else {

            return {
                start: BaseModel.parseDate(start.start ? start.start : null),
                end: BaseModel.parseDate(start.end ? start.end : null)
            };
        }
    }

    /**
     * @param {string} dateToParse
     * @returns {Moment}
     */
    static parseDate (dateToParse) {

        if (!dateToParse) {
            dateToParse = BaseModel.DEFAULT_DATE;
        }

        return moment.tz(dateToParse, BaseModel.timezone);
    }

    /**
     * @param dateToSerialize
     * @returns {string|null}
     */
    static serializeDate (dateToSerialize) {

        return (dateToSerialize ? dateToSerialize.toISOString() : null);
    }

    /**
     * @param period
     * @returns {{start: string, end: string}}
     */
    static serializePeriod (period) {

        return {
            start: BaseModel.serializeDate(period.start),
            end: BaseModel.serializeDate(period.end)
        };
    }

    static get DEFAULT_DATE () {

        return '1970-01-01T00:00:00+00:00';
    }

    static get timezone () {

        return BaseModel._timezone;
    }

    static set timezone (timezone) {

        BaseModel._timezone = timezone;
    }

    static getLocalMoment () {

        return moment().tz(BaseModel.timezone);
    }

    update (changedAttributes) {

        if (!changedAttributes) {
            changedAttributes = this.changedAttributes();
        } else {
            this.set(changedAttributes);
        }

        return this
            .save(changedAttributes, {
                patch: true,
                headers: {
                    'Content-Type': 'application/merge-patch+json',
                    'If-Match': this.attributes.etag,
                }
            });
    }
}

BaseModel.timezone = __('_TIMEZONE');


// WEBPACK FOOTER //
// ./shared/model/base/BaseModel.js